import React, { useState, useEffect } from "react";
import "../components/App.css";
import axios from "axios";
import { API_BASE_URL } from "../config/config";
import dayjs from "dayjs";
import {
  Container,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { useActiveCareUser } from "../hooks/useActiveCareUser";

const ReferAndEarn = () => {
  const [earnings, setEarnings] = useState(null);
  const { userDetails } = useActiveCareUser();

  useEffect(() => {
    const fetchEarnings = async () => {
      try {
        const token = localStorage.getItem("care_token");
        const earningsResponse = await axios.get(
          `${API_BASE_URL}/earnings/${userDetails._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setEarnings(earningsResponse.data);
      } catch (error) {
        console.error("Error fetching earnings:", error);
      }
    };

    if (userDetails?._id) {
      fetchEarnings();
    }
  }, [userDetails]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <Container>
      <div className="redirect-container">
          <div className="refer-container">
            <h3
              style={{
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "1rem",
              }}
            >
              Refer and Earn Cash back
            </h3>
            <p style={{ textAlign: "center" }}>
              Invite your contacts list and refer link of company with your
              referral code and Get assured cash back on their subscription
              activation!
            </p>
            <p style={{ textAlign: "center" }}>
              <span
                style={{ color: "blue", cursor: "pointer" }}
                onClick={() => copyToClipboard(userDetails.refcode)}
              >
                Copy your referral Link to Clipboard
              </span>
            </p>
            <p style={{ textAlign: "center" }}>
              As soon as yours referred lead once subscribe for product care
              from link you shared at the same time your account will be credited
              with 20% of their value of purchase.
            </p>
          </div>
          <div className="earnings-container">
            <h3 style={{ textAlign: "center", fontWeight: "bold" }}>
              My Earnings Table
            </h3>
            <Table style={{ margin: "0 auto" }}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Referral ID</b>
                  </TableCell>
                  <TableCell>
                    <b>Date</b>
                  </TableCell>
                  <TableCell>
                    <b>Amount</b>
                  </TableCell>
                  <TableCell>
                    <b>Currency</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {earnings &&
                  Array.isArray(earnings.records) &&
                  earnings.records.map((earning, index) => (
                    <TableRow key={index}>
                      <TableCell>{earning.refid}</TableCell>
                      <TableCell>
                        {dayjs(earning.date).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell>{earning.amount}</TableCell>
                      <TableCell>{earning.currency}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
          <div className="earnings-container">
            <h3 style={{ textAlign: "center", fontWeight: "bold" }}>
              Payout Your Earnings
            </h3>
            <Table style={{ margin: "0 auto" }}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Referral ID</b>
                  </TableCell>
                  <TableCell>
                    <b>Fill the Payout Link</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {earnings &&
                  Array.isArray(earnings.records) &&
                  earnings.records.map((earning, index) => (
                    <TableRow key={index}>
                      <TableCell>{earning.refid}</TableCell>
                      <TableCell>
                        <a
                          href={earning.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Link
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </div>
    </Container>
  );
};

export default ReferAndEarn;
